import { computed } from "vue"
import type { Ref } from "vue"
import { Role } from "./graphql/types"
import {comparePrivilege} from "./privileges/plugin"

export function useAllPrivileges(): Ref<Role[]> {
    return computed<Role[]>(() => {
        return (Object.values(Role) as Role[]).sort(comparePrivilege)
    })
}
